import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { useGetFollowUps } from './data';
import FollowUpsTable from './FollowUpsTable.jsx';
import LoadingComponent from '../../../../shared/LoadingComponent';

const FollowUpSection = styled.div`
  background-color: ${themeGet('colors.white')};
  border: solid 1px ${themeGet('colors.black.10')};
  margin-top: 24px;
  border-radius: 8px;
  padding: 16px 24px 24px 24px;
  font-family: Montserrat, sans-serif;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export default function FollowUps() {
  const { isLoading, data = [] } = useGetFollowUps();

  return (
    <FollowUpSection>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <FollowUpsTable data={data.follow_ups} />
      )}
    </FollowUpSection>
  );
}
